import React from 'react';
import { Body1, Heading5 } from '../Typography';
import { ReactComponent as ArrowMore } from '../../assets/svg/arrow-more.svg';

import styles from './index.module.scss';
import { ButtonVariants } from '../Button';
import OuterLink from '../OuterLink';

const INFO_BANNER_TYPE = {
  // Info will open info modal (drawer)
  INFO: 'info',
  // Link will open link in new tab
  LINK: 'link',
  // It has button with text and link
  BUTTON_LINK: 'buttonLink',
};

interface InfoBannerProps {
  title: string;
  description: string;
  type?: string;
  backgroundColor: string;
  url?: string;
  handleInfo: () => void;
  button?: {
    link: string;
    text: string;
  };
}

const InfoBanner: React.FC<InfoBannerProps> = ({
  title,
  description,
  type,
  backgroundColor,
  url,
  button,
  handleInfo,
}) => {
  if (type === INFO_BANNER_TYPE.BUTTON_LINK) {
    return (
      <div className={styles.wrapper} style={{ background: backgroundColor }}>
        <div className={styles.innerWrapper}>
          <div className={styles.titleWrapper}>
            <Heading5>{title}</Heading5>
          </div>
          {description && (
            <Body1 className={styles.description}>{description}</Body1>
          )}
          {button && (
            <OuterLink
              variant={ButtonVariants.OUTLINED}
              size='normal'
              className={styles.button}
              href={button.link}
            >
              {button.text}
            </OuterLink>
          )}
        </div>
      </div>
    );
  }

  if (type === INFO_BANNER_TYPE.INFO) {
    return (
      <div className={styles.wrapper}>
        <button
          onClick={handleInfo}
          className={`${styles.innerWrapper} ${styles.buttonInnerWrapper}`}
          style={{ background: backgroundColor }}
        >
          <div className={styles.titleWrapper}>
            <Heading5 className={styles.title}>{title}</Heading5>
            <ArrowMore className={styles.icon} />
          </div>
          {description && (
            <Body1 className={styles.description}>{description}</Body1>
          )}
        </button>
      </div>
    );
  }

  // In case of type is not provided or type is LINK
  return (
    <div className={styles.wrapper}>
      <a
        href={url}
        className={`${styles.innerWrapper} ${styles.buttonInnerWrapper}`}
        style={{ background: backgroundColor }}
      >
        <div className={styles.titleWrapper}>
          <Heading5 className={styles.title}>{title}</Heading5>
          <ArrowMore />
        </div>
        {description && (
          <Body1 className={styles.description}>{description}</Body1>
        )}
      </a>
    </div>
  );
};

export default InfoBanner;
